import { Icon } from '@iconify/react';
import { FieldWrapper } from '@progress/kendo-react-form';
import { InputPrefix, InputSuffix, TextBox } from '@progress/kendo-react-inputs';
import { Label } from '@progress/kendo-react-labels';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

interface PunchoutOrderGuideHeaderProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
}

const PunchoutOrderGuideHeader = ({
  searchValue,
  onSearchChange,
}: PunchoutOrderGuideHeaderProps) => {
  const { t } = useTranslation();

  const handleClearSearch = useCallback(() => {
    onSearchChange('');
  }, [onSearchChange]);

  return (
    <div className="mb-2 mt-4 flex w-full flex-wrap items-center justify-between gap-4 px-4">
      <div className="flex min-w-[280px] max-w-[550px] flex-[1_1_350px] items-center gap-2">
        <FieldWrapper className="flex w-full flex-row items-center space-x-2">
          <Label
            editorId="punchout-order-guide-filter-input"
            className="flex items-center whitespace-nowrap text-xs font-semibold"
          >
            {t('Filter By')}
          </Label>
          <TextBox
            id="punchout-order-guide-filter-input"
            max={500}
            maxLength={500}
            size="medium"
            style={{ fontSize: '14px' }}
            placeholder={t('Enter Item # or Description')}
            width="100%"
            value={searchValue}
            onChange={(event) => onSearchChange(String(event.value ?? ''))}
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck={false}
            prefix={() => (
              <InputPrefix className="pl-2">
                <Icon height="18" width="18" color="#AAAAAA" icon="lucide:search" />
              </InputPrefix>
            )}
            suffix={() => (
              <InputSuffix className="pr-2">
                {searchValue && (
                  <button
                    type="button"
                    onClick={handleClearSearch}
                    aria-label={t('clearSearch')}
                    className="flex items-center justify-center"
                  >
                    <Icon height="16" width="16" color="#AAAAAA" icon="lucide:x" />
                  </button>
                )}
              </InputSuffix>
            )}
          />
        </FieldWrapper>
      </div>
    </div>
  );
};

export default PunchoutOrderGuideHeader;
